<template>
	<div>
        <input v-for="input in file_inputs"
               :id="input.id"
               v-on:change="uploadNewFile"
               v-on:click="blockInteraction"
               type="file"
               :name="input.name"
               class="d-none"/>

        <button class="btn d-inline-flex" v-bind:class="color_class" v-on:click="openDialog" v-bind:disabled="uploading">
            <span>Add Documents</span>
            <div v-if="uploading" class="loaders--small loaders--light-grey ml-3"></div>
        </button>

        <upload-file-modal
            title="Document"
            :upload_url="upload_url"
            ref="modal"
            @uploaded="$emit('uploaded', $event)"
        ></upload-file-modal>
    </div>
</template>

<script>
    import UploadFileModal from "../modals/UploadFileModal";
    export default {
        name: "JobFileUploadButton",
        components: {UploadFileModal},
        props: {
            upload_url: {
                type: String,
                required: true
            },

            color: {
                type: String,
                default: 'primary'
            }
        },

        data(){
            return {
                indexer: 0,
                file_inputs: [],
                files_edit: [],
                uploading: false
            }
        },

        beforeMount(){
            this.files_edit = this.files || [];
        },

        methods: {
            blockInteraction (e){
                if (e.target.files.length){
                    e.preventDefault();
                    return;
                }
            },

            uploadNewFile(e){
                let files_in_input = e.target.files || e.dataTransfer.files;

                if (!files_in_input.length){
                    if (typeof e.target.remove === 'function') {
                        e.target.remove();
                    } else {
                        e.target.parentNode.removeChild(e.target);
                    }
                    return;
                }

                this.$refs.modal.open(files_in_input[0]);
            },

            openDialog(){
                let _this = this;

                _this.indexer ++;

                _this.file_inputs.push({
                    id: 'file_uploader-' +_this.indexer,
                    name: 'file-' + _this.indexer
                });

                window.setTimeout(function (){
                    document.getElementById('file_uploader-' + _this.indexer).click();

                    document.body.onfocus = function(){
                        document.body.onfocus = null;

                        window.setTimeout(function (){
                            if (document.getElementById('file_uploader-' + _this.indexer).files.length === 0){
                                _this.file_inputs.pop();
                            }
                        }, 500);
                    };
                }, 150);
            },
        },

        computed: {
            color_class(){
                return 'btn-' + this.color;
            }
        }
    }
</script>
